/* eslint-disable operator-linebreak */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { ICashFlowBudgetClassification } from 'views/ProFormaTable/types';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import RenderIf from 'components/RenderIf/RenderIf';
import classNames from 'classnames';
import { getProjectActualsCategoryLevelTotals } from 'views/ProFormaTable/helpers';
import { Periods } from 'components/ProFormaReturnsTable/constant';
import { useUsesActualsTableContext } from '../context/UsesTableActualsProvider';
import UsesTableSubcategoryActuals from './UsesTableSubcategoryActuals/UsesTableSubcategoryActuals';
import { useProFormaSocketContext } from '../../../socketContext/ProFormaSocketProvider';
import ProjectActualsCashFlowPeriods from '../ProjectActualsCashFlowPeriods/ProjectActualsCashFlowPeriods';

export interface IUsesTableHighLevelActuals {
    highLevel: ICashFlowBudgetClassification;
}

const UsesTableHighLevelActuals = ({ highLevel }: IUsesTableHighLevelActuals) => {
    const { periodCadence, showCents } = useProFormaSocketContext();

    const {
        expandedActualsCategories, updateExpandedActualsCategories, forecastMetric,
        isEarlyPlanningProject, selectedScenario,
    } = useUsesActualsTableContext();

    const showCentsFormat = showCents ? '$0,0.00' : '$0,0';
    const subcategoryIds: string[] = [];
    const budgetClassificationIds: string[] = [];

    highLevel.children?.map(subcategory => {
        subcategoryIds.push(subcategory.nodeName);
        subcategory.children?.map(budgetClassification => budgetClassificationIds.push(budgetClassification.nodeName));
        return null;
    });

    const categoryTotals = getProjectActualsCategoryLevelTotals(forecastMetric, highLevel, isEarlyPlanningProject, selectedScenario);

    let periods = highLevel.periodData || [];
    if (periodCadence === Periods.ANNUALLY) {
        periods = highLevel.yearlyPeriodData || [];
    }

    return (
        <>
            <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-1 text-dark">
                <td
                    className="NSTable__tbody__tr__td NSTable__tbody__tr__td--right-border"
                >
                    <div className="d-flex">
                        <div
                            role="presentation"
                            onClick={() => {
                                updateExpandedActualsCategories(highLevel.id, null);
                            }}
                        >
                            <RenderIf isTrue={Boolean(highLevel.children?.length)}>
                                <FontAwesomeIcon
                                    className="icon mr-1 ReadOnlyWrapper--enable-pointer-events"
                                    icon={expandedActualsCategories.highLevels.includes(highLevel.id) ? faCaretDown : faCaretRight}
                                    fixedWidth
                                />
                            </RenderIf>
                            <span className={classNames({ 'ml-3': !highLevel.children?.length })}>{highLevel.description}</span>
                        </div>
                    </div>
                </td>
                <td className="NSTable__tbody__tr__td" />
                <td className="NSTable__tbody__tr__td">
                    <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.budgetTotal, showCentsFormat)}</div>
                </td>
                <td className="NSTable__tbody__tr__td">
                    <div className="d-flex justify-content-end">{numeralFormatterCurrency(categoryTotals.balanceRemaining, showCentsFormat)}</div>
                </td>
                <td className="NSTable__tbody__tr__td" />
                <td className="NSTable__tbody__tr__td" />

                <ProjectActualsCashFlowPeriods
                    periods={periods}
                    showCentsFormat={showCentsFormat}
                />

            </tr>

            <RenderIf isTrue={expandedActualsCategories.highLevels.includes(highLevel.id)}>
                {(highLevel.children || []).map(subcategory => (
                    <UsesTableSubcategoryActuals
                        key={subcategory.nodeName}
                        subcategory={subcategory}
                    />
                ))}
            </RenderIf>
        </>
    );
};

export default UsesTableHighLevelActuals;
